module.exports = __webpack_public_path__ + "img/1-5.5c4528cf.svg";